<ng-container [ngSwitch]="activeTemplate$ | async">
    <ng-container *ngSwitchCase="'DefaultView'">
        <ng-container *ngIf="versionToggle.isQLButNotConsumerQL()" [ngTemplateOutlet]="cd_ql_notconsumer"></ng-container>
        <ng-container *ngIf="versionToggle.isNotQLOrConsumerQL()" [ngTemplateOutlet]="cd_ql_consumer"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'ProductDetail'">
        <ng-container [ngTemplateOutlet]="cd_single_product"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'SelectedItemActions'">
        <ng-container [ngTemplateOutlet]="cd_selected_item_actions"></ng-container>
    </ng-container>
</ng-container>

<ng-template #cd_ql_consumer>
    <div class="contract-details-page" [class.sticky-added]="isSticky">
        <ng-container *ngIf="(appFacadeService.isPaymentSectionEnabled() | async) === false">
            <div class="header-section">
                <div class="header">
                    <h1 class="theme-heading">
                        <ng-container *ngIf="isStatus('Quote'); else contractDetailsHeader">{{ 'Quote Details' | translate }}</ng-container>
                        <ng-template #contractDetailsHeader>{{ 'Contract Details' | translate }}</ng-template>
                    </h1>
                    <por-base-button [featureName]="'contract-detail-close'" (click)="onCloseButtonClick()" icon="close"></por-base-button>
                </div>
            </div>
            <div class="quote-status-banner" *ngIf="isStatus('Quote')">
                <div class="quote-banner-content">
                    <mat-icon class="quote-banner-icon">info</mat-icon>
                    <span class="quote-banner-text">{{ 'QuoteStatusBannerMessage' | translate }}</span>
                </div>
            </div>
            <por-quote-step-tracker
                *ngIf="showStepTracker"
                [status]="quoteStepStatus"
                [autoConvertEnabled]="autoConvertQuotes"
                [converted]="isStatus('Reservation')"
                [storeName]="(appFacadeService.getConfig() | async)?.storeName"
                (goToStep)="onGoToStep($event)"></por-quote-step-tracker>
            <div class="content" *ngIf="contractDetail">
                <ng-container *ngFor="let detail of contractDetail">
                    <div>
                        <ng-container [ngTemplateOutlet]="cd_common_dates"></ng-container>

                        <div class="detail">
                            <ng-container [ngTemplateOutlet]="cd_common_stats"></ng-container>
                            <ng-container [ngTemplateOutlet]="cd_common_pay_btns" *ngIf="!isMobile"></ng-container>
                        </div>
                        <ng-container [ngTemplateOutlet]="cd_common_line_item_table"></ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container [ngTemplateOutlet]="cd_common_payment"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_common_footer_mobile"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_ql_common_footer"></ng-container>
    </div>
</ng-template>

<ng-template #cd_ql_notconsumer>
    <div class="contract-details-page" [ngClass]="{ 'quick-link': true, 'display-block': (appFacadeService.isPaymentSectionEnabled() | async) }" [class.sticky-added]="isSticky">
        <div class="quote-status-banner" *ngIf="isStatus('Quote') && (appFacadeService.isPaymentSectionEnabled() | async) === false">
            <div class="quote-banner-content">
                <mat-icon class="quote-banner-icon">info</mat-icon>
                <span class="quote-banner-text">{{ 'QuoteStatusBannerMessage' | translate }}</span>
            </div>
        </div>
        <por-quote-step-tracker
            *ngIf="showStepTracker && (appFacadeService.isPaymentSectionEnabled() | async) === false"
            [status]="quoteStepStatus"
            [autoConvertEnabled]="autoConvertQuotes"
            [converted]="isStatus('Reservation')"
            [storeName]="(appFacadeService.getConfig() | async)?.storeName"
            [hideWarning]="showIncompleteStepsBanner()"
            [showEsignButton]="!isEsignAccordionVisible"
            (goToStep)="onGoToStep($event)"></por-quote-step-tracker>
        <div class="content" *ngIf="contractDetail && (appFacadeService.isPaymentSectionEnabled() | async) === false">
            <ng-container *ngFor="let detail of contractDetail">
                <div class="quick-link-version">
                    <ng-container *ngIf="isMobile" [ngTemplateOutlet]="cd_ql_notconsumer_mobile" [ngTemplateOutletContext]="{ detail: detail }"></ng-container>
                    <ng-container *ngIf="!isMobile" [ngTemplateOutlet]="cd_ql_notconsumer_desktop"></ng-container>
                </div>
            </ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="cd_common_payment"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_common_footer_mobile"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_ql_common_footer"></ng-container>
    </div>
</ng-template>

<ng-template #cd_single_product>
    <ng-container>
        <div class="product-detail" *ngIf="(appFacadeService.getProductDetail() | async)?.productDetail">
            <por-product-detail (closePanel)="onCloseProductDetail()" [uiUrl]="uiUrl" />
        </div>
    </ng-container>
</ng-template>

<ng-template #cd_selected_item_actions>
    <por-selected-item-actions
        (closePanel)="setActiveTemplateTab('DefaultView')"
        [lineItem]="selectedLineItem"
        [uiUrl]="uiUrl"
        [customerId]="customerId"
        [contractDetail]="contractDetail?.[0]"></por-selected-item-actions>
</ng-template>

<ng-template #cd_ql_notconsumer_mobile let-detail="detail">
    <div>
        <div class="action-buttons" *ngIf="hideActionButtons()" [class.sticky]="isSticky">
            <ng-container [ngTemplateOutlet]="cd_common_selected_item_documents"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="cd_esign" [ngTemplateOutletContext]="{ detail: detail }"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_payment_information" [ngTemplateOutletContext]="{ detail: detail }"></ng-container>
        <por-accordion>
            <por-accordion-group title="{{ 'information' | translate }}">
                <div class="stats">
                    <p>
                        <label *ngIf="isStatus('Quote'); else qlMobileContractLabel" porAddFeature featureName="contract-detail-quote-label">{{ 'Quote' | translate }}#</label>
                        <ng-template #qlMobileContractLabel>
                            <label porAddFeature featureName="contract-detail-quote-label">{{ 'contract' | translate }}#</label>
                        </ng-template>
                        <span>{{ detail?.Name }}</span>
                    </p>
                    <p>
                        <label porAddFeature featureName="contract-detail-start-date-label">
                            <ng-container *ngIf="isStatus('Quote'); else qlMobileStartDateLabel">{{ 'Quote Start Date' | translate }}</ng-container>
                            <ng-template #qlMobileStartDateLabel>{{ 'Start Date' | translate }}</ng-template>
                        </label>
                        <span>{{ detail.StartDateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                    </p>

                    <p *ngIf="detail.EndDateTime">
                        <label porAddFeature featureName="contract-detail-end-date-label">
                            <ng-container *ngIf="isStatus('Quote'); else qlMobileEndDateLabel">{{ 'Quote End Date' | translate }}</ng-container>
                            <ng-template #qlMobileEndDateLabel>{{ 'End Date' | translate }}</ng-template>
                        </label>
                        <span>{{ detail.EndDateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                    </p>
                    <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                        <p>
                            <label porAddFeature featureName="contract-detail-grand-total-label" class="label-relative">
                                {{ 'Grand Total' | translate }}
                            </label>
                            <span>{{ detail.GrandTotal | formatCurrency }}</span>
                        </p>
                    </ng-template>
                    <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                        <ng-template porFeatureAvailability [featureToken]="['canSeeContractDetailTotalPaid']">
                            <p *ngIf="contractService.getContractTotalPaid(detail) > 0">
                                <label porAddFeature featureName="contract-detail-total-paid-label" class="label-relative">
                                    {{ 'TotalPaid' | translate }}
                                    <span
                                        porIcon
                                        icon="info"
                                        class="payment-info quicklink mt-05"
                                        *ngIf="
                                            (appFacadeService.getContractDetailPaymentHistory() | async) &&
                                            versionToggle.isAdvanceVersion() &&
                                            featureToggleService.isAvailable('Account.PaymentHistory')
                                        "
                                        (click)="openPaymentHistoryModal()"
                                        title="{{ 'OnlinePaymentHistory' | translate }}"></span>
                                </label>
                                <span>{{ contractService.getContractTotalPaid(detail) | formatCurrency }}</span>
                            </p>
                        </ng-template>
                    </ng-template>
                </div>
            </por-accordion-group>
            <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                <ng-template porFeatureAvailability [featureToken]="['canSeeBalance']">
                    <p class="last-states">
                        <label porAddFeature featureName="contract-detail-amount-due-label">{{ 'AmountDue' | translate }}:</label>
                        <ng-container>
                            <span *ngIf="isPending; else showDash">{{ 'Pending' | translate }}</span>
                            <ng-template #showDash>
                                <span>{{ detail.AmountDue | formatCurrency }}</span>
                            </ng-template>
                        </ng-container>
                    </p>
                </ng-template>
            </ng-template>
            <por-accordion-group title="{{ 'items' | translate }}">
                <ng-container [ngTemplateOutlet]="cd_common_line_item_table"></ng-container>
            </por-accordion-group>
        </por-accordion>
    </div>
</ng-template>

<ng-template #cd_ql_notconsumer_desktop>
    <div>
        <ng-container [ngTemplateOutlet]="cd_common_dates"></ng-container>
        <div class="detail">
            <ng-container [ngTemplateOutlet]="cd_common_stats"></ng-container>
            <ng-container [ngTemplateOutlet]="cd_common_pay_btns"></ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="cd_common_line_item_table"></ng-container>
    </div>
</ng-template>

<ng-template #cd_ql_common_footer>
    <div *ngIf="versionToggle.isQuickLinkVersion() && versionToggle.isAdvanceVersion() && (!isMobile || (appFacadeService.isPaymentSectionEnabled() | async) === false)">
        <por-ad-images [customerId]="customerId" [layout]="'columns4'"></por-ad-images>
    </div>
</ng-template>

<ng-template #cd_common_footer_mobile>
    <div class="quick-link-pay-btns-mobiles" *ngIf="isMobile && (appFacadeService.isPaymentSectionEnabled() | async) === false">
        <ng-container [ngTemplateOutlet]="cd_common_pay_btns"></ng-container>
    </div>
</ng-template>

<ng-template #cd_common_payment>
    <div class="content">
        <ng-container *ngIf="contractDetail && (appFacadeService.isPaymentSectionEnabled() | async)">
            <por-payment-page
                [contract]="contractDetail[0]"
                [customerId]="customerId"
                [organizationId]="organizationId"
                [enableBackButton]="true"
                (paymentSuccess)="onSuccessTransaction($event)"
                (closePanel)="enablePaymentPage(false)"></por-payment-page>
        </ng-container>
    </div>
</ng-template>

<ng-template #cd_common_stats>
    <ng-container *ngFor="let detail of contractDetail">
        <div class="stats">
            <p>
                <label *ngIf="isStatus('Quote'); else contractLabel" porAddFeature featureName="contract-detail-quote-label">{{ 'Quote' | translate }}#</label>
                <ng-template #contractLabel>
                    <label porAddFeature featureName="contract-detail-quote-label">{{ 'contract' | translate }}#</label>
                </ng-template>
                <span>{{ detail?.Name }}</span>
            </p>
            <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                    <p>
                        <label porAddFeature featureName="contract-detail-contract-total-label">{{ 'contractTotal' | translate }}</label>
                        <span>{{ getContractTotal() | formatCurrency }}</span>
                    </p>
                    <p>
                        <label porAddFeature featureName="contract-detail-total-tax-label">{{ 'totalTax' | translate }}</label>
                        <span>{{ detail?.GrandTaxTotal | formatCurrency }}</span>
                    </p>
                    <p class="last-states">
                        <label porAddFeature featureName="contract-detail-grand-total-label" class="label-relative">
                            {{ 'Total' | translate }}
                        </label>
                        <span>{{ detail.GrandTotal | formatCurrency }}</span>
                    </p>
                </ng-template>
            </ng-template>
            <ng-template porFeatureAvailability [featureToken]="['canSeeBalance']">
                <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                    <p class="ml-2 font-weight-600 mml-0">
                        <label porAddFeature featureName="contract-detail-balance-label">{{ 'Amount Due' | translate }}</label>
                        <ng-container>
                            <span *ngIf="isPending; else showDash">{{ 'Pending' | translate }}</span>
                            <ng-template #showDash>
                                <span>{{ detail.AmountDue | formatCurrency }}</span>
                            </ng-template>
                        </ng-container>
                    </p>
                </ng-template>
            </ng-template>
            <ng-template porFeatureAvailability [featureToken]="['canSeeContractDetailTotalPaid']">
                <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                    <p *ngIf="contractService.getContractTotalPaid(detail) > 0">
                        <label porAddFeature featureName="contract-detail-total-paid-label" class="label-relative">
                            {{ 'TotalPaid' | translate }}
                            <span
                                porIcon
                                icon="info"
                                class="payment-info"
                                *ngIf="(appFacadeService.getContractDetailPaymentHistory() | async) && versionToggle.isAdvanceVersion() && featureToggleService.isAvailable('Account.PaymentHistory')"
                                (click)="openPaymentHistoryModal()"
                                title="{{ 'OnlinePaymentHistory' | translate }}"></span>
                        </label>
                        <span>{{ contractService.getContractTotalPaid(detail) | formatCurrency }}</span>
                    </p>
                </ng-template>
            </ng-template>
            <ng-template porFeatureAvailability [featureToken]="['canSeeContractDetailSiteField']">
                <p class="text-align-left" *ngIf="detail?.Site">
                    <label porAddFeature featureName="contract-detail-site-label">{{ 'location' | translate }}</label>
                    <span>{{ detail?.Site }}</span>
                </p>
            </ng-template>
        </div>
    </ng-container>
</ng-template>

<ng-template #cd_common_dates>
    <ng-container *ngFor="let detail of contractDetail">
        <div class="action-buttons" *ngIf="hideActionButtons()">
            <ng-container [ngTemplateOutlet]="cd_common_selected_item_documents"></ng-container>
        </div>
        <hr class="spliter" [ngClass]="{ 'show-line': ((isPaymentProcessorAvailable$ | async) && isPaymentEnabled) || checkEsignButton() }" />
        <ng-container [ngTemplateOutlet]="cd_esign" [ngTemplateOutletContext]="{ detail: detail }"></ng-container>
        <ng-container [ngTemplateOutlet]="cd_payment_information" [ngTemplateOutletContext]="{ detail: detail }"></ng-container>
        <div class="dates">
            <div>
                <p *ngIf="versionToggle.isNotQLOrConsumerQL()">
                    <label porAddFeature featureName="contract-detail-customer-name-label">{{ 'Customer' | translate }}:</label>
                    <span>{{ detail?.CustomerName }}</span>
                </p>
            </div>
            <div>
                <p>
                    <label porAddFeature featureName="contract-detail-start-date-label">
                        <ng-container *ngIf="isStatus('Quote'); else contractStartDateLabel">{{ 'Quote Start Date' | translate }}</ng-container>
                        <ng-template #contractStartDateLabel>{{ 'Contract Start Date' | translate }}</ng-template>
                        :
                    </label>
                    <span>{{ detail.StartDateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                </p>

                <p *ngIf="versionToggle.isNotQLOrConsumerQL() && detail.DriverDelivery && detail.DriverDelivery.DateTime">
                    <label porAddFeature featureName="contract-detail-delivery-date-label">{{ 'Delivery Date' | translate }} :</label>
                    <span>{{ detail.DriverDelivery.DateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                </p>
            </div>
            <div>
                <p *ngIf="detail.EndDateTime">
                    <label porAddFeature featureName="contract-detail-end-date-label">
                        <ng-container *ngIf="isStatus('Quote'); else endDateLabel">{{ 'Quote End Date' | translate }}</ng-container>
                        <ng-template #endDateLabel>{{ 'End Date' | translate }}</ng-template>
                        :
                    </label>
                    <span>{{ detail.EndDateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                </p>
                <p *ngIf="versionToggle.isNotQLOrConsumerQL() && this.hasPickupDate()">
                    <label porAddFeature featureName="contract-detail-pickup-date-label">{{ 'Pickup Date' | translate }} :</label>
                    <span>{{ detail.DriverPickup.DateTime | depotTimezoneDate : 'full' : detail.DepotId | async }}</span>
                </p>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #cd_esign let-detail="detail">
    <por-accordion-group
        *ngIf="isEsignAccordionVisible"
        [opened]="getEsignStepStatus(detail) !== 'complete' || !!esignMsg"
        [class.esign-state-complete]="getEsignStepStatus(detail) === 'complete'"
        [class.esign-state-incomplete]="getEsignStepStatus(detail) === 'incomplete'"
        [class.esign-state-pending]="getEsignStepStatus(detail) === 'pending'"
        title="{{ 'eSign' | translate }}">
        <div class="payment-cta-wrapper">
            <por-base-button [theme]="'primary'" [featureName]="'esign'" [disabled]="getEsignStepStatus(detail) === 'complete'" (click)="startEsign()">
                <span class="line-splitter">
                    {{ 'Sign your contract' | translate }}
                    <span aria-hidden="true">→</span>
                </span>
            </por-base-button>
        </div>
        <p class="esign-msg" *ngIf="esignMsg">
            <span>{{ esignMsg }}</span>
        </p>
    </por-accordion-group>
</ng-template>

<!-- ADO-104813: Payment Information accordion. Shown only with the View Payments permission (AC4) +
     Payment Required toggle (AC7) + Syrinx Cash customer (AC1). Rendered in both desktop and mobile
     via ngTemplateOutlet. The shared AccordionGroupComponent is intentionally left untouched; the
     completion badge (AC2) and payment button are rendered locally in the projected content. -->
<ng-template #cd_payment_information let-detail="detail">
    <por-accordion-group
        *ngIf="isPaymentAccordionVisible"
        [opened]="getPaymentStepStatus(detail) !== 'complete'"
        [class.payment-state-complete]="getPaymentStepStatus(detail) === 'complete'"
        [class.payment-state-incomplete-required]="getPaymentStepStatus(detail) === 'incomplete' && paymentRequired"
        [class.payment-state-incomplete-not-required]="getPaymentStepStatus(detail) === 'incomplete' && !paymentRequired"
        [class.payment-state-pending]="getPaymentStepStatus(detail) === 'pending'"
        title="{{ 'PaymentInformation' | translate }}">
        <ng-container *ngIf="getPaymentStepStatus(detail) === 'pending'">
            <por-busy-indicator [message]="'Loading...' | translate"></por-busy-indicator>
        </ng-container>
        <ng-container *ngIf="getPaymentStepStatus(detail) !== 'pending'">
            <!-- AC2: local completion badge — rendered in the accordion header via the payment-state-* classes (see _common.scss). -->
            <!-- Red-state amount display: shown whenever the badge is incomplete. Excluded when the
                 payment-boundary-summary fallback below would also render, so "AmountToHoldReservation"
                 never appears twice. -->
            <ng-container
                *ngIf="
                    getPaymentStepStatus(detail) === 'incomplete' &&
                    isStatus('Quote') &&
                    isPaymentMinimumDisplayable() &&
                    !isPaymentBoundarySummaryVisible(detail, isPaymentProcessorAvailable$ | async)
                ">
                <p class="payment-minimum-due">
                    <span class="label">{{ 'AmountToHoldReservation' | translate }}:</span>
                    {{ paymentMinimum | formatCurrency }}
                </p>
            </ng-container>
            <!-- AC3/AC4: every POR Pay payment across sessions. -->
            <ng-template porFeatureAvailability [featureToken]="['Account.PaymentHistory']">
                <div class="table-responsive" *ngIf="detail?.Payment?.length > 0">
                    <table class="table">
                        <thead>
                            <th>{{ 'PaidOnDate' | translate }}</th>
                            <th>{{ 'TotalOnlinePayment' | translate }}</th>
                            <th>{{ 'ReferenceNumber' | translate }}</th>
                        </thead>
                        <tbody>
                            @for (receivedPayment of detail?.Payment; track receivedPayment) {
                            <tr>
                                <td class="text-center">{{ receivedPayment.PaidDateTime | formatDate : featureToggleService.isSyrinx() }}</td>
                                <td class="text-center">{{ receivedPayment.TotalPaid | formatCurrency }}</td>
                                <td class="text-center">{{ receivedPayment.ReferenceNumber }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </ng-template>

            <!-- "Make a payment" button — shown here when the accordion is visible (standalone copy is suppressed).
                 ADO-120176: no icon/split-button sizing; .payment-cta-wrapper centers it (por-base-button
                 doesn't center itself within an arbitrary parent). -->
            <ng-container *ngIf="isPaymentProcessorAvailable$ | async">
                <div class="payment-cta-wrapper" *ngIf="isPaymentEnabled">
                    <por-base-button [theme]="'primary'" [featureName]="'payment-button'" (click)="enablePaymentPage(true)">
                        <span class="line-splitter">
                            {{ 'Make a payment' | translate }}
                            <span aria-hidden="true">→</span>
                        </span>
                    </por-base-button>
                </div>
            </ng-container>

            <!-- Fallback: when neither the payment-history table nor the "Make a payment" button renders,
                 surface the payment boundaries (min/max per method) so the accordion is not empty. -->
            <div class="payment-boundary-summary" *ngIf="isPaymentBoundarySummaryVisible(detail, isPaymentProcessorAvailable$ | async)">
                @for (boundary of paymentBoundaries; track boundary.paymentMethod) {
                <div class="payment-boundary-row">
                    <p>
                        <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                        {{ getPaymentMethodName(boundary.paymentMethod) }}
                    </p>
                    <p>
                        <span class="label">{{ 'AmountToHoldReservation' | translate }}:</span>
                        {{ boundary.minAmount | formatCurrency }}
                    </p>
                    <p>
                        <span class="label">{{ 'TotalDue' | translate }}:</span>
                        {{ boundary.maxAmount | formatCurrency }}
                    </p>
                </div>
                } @if (paymentBoundaries.length === 0) {
                <div class="payment-boundary-row">
                    <p>
                        <span class="label">{{ 'IssueWithPaymentBoundary' | translate }}</span>
                    </p>
                </div>
                }
            </div>
        </ng-container>
    </por-accordion-group>
</ng-template>

<ng-template #cd_common_pay_btns>
    <ng-container *ngFor="let detail of contractDetail">
        <div class="pay-btns">
            <ng-template
                porFeatureAvailability
                [featureToken]="['contractCancel']"
                [options]="{ subFeature: 'canContractCancel', state: detail?.Status ?? detail?.ContractStatus ?? '' }"
                porFeatureAvailability
                [featureToken]="['contractEdit']"
                [options]="{ subFeature: 'canContractEdit', state: detail?.Status ?? detail?.ContractStatus ?? '' }">
                <span class="actions-btns">
                    <ng-template porFeatureAvailability [featureToken]="['contractEdit']" [options]="{ subFeature: 'canContractEdit', state: detail?.Status ?? detail?.ContractStatus ?? '' }">
                        <por-base-button [theme]="'primary'" [class]="'edit-button'" [featureName]="'edit-button'" (click)="editContract(detail.Id)">
                            <img class="actions-image" src="{{ uiUrl }}/assets/images/edit.svg" />
                        </por-base-button>
                    </ng-template>
                    <ng-template porFeatureAvailability [featureToken]="['contractCancel']" [options]="{ subFeature: 'canContractCancel', state: detail?.Status ?? detail?.ContractStatus ?? '' }">
                        <por-base-button [theme]="'primary'" [class]="'cancel-button'" [featureName]="'cancel-button'" (click)="toggleDialog()">
                            <img class="actions-image" src="{{ uiUrl }}/assets/images/cancel.svg" />
                        </por-base-button>
                    </ng-template>
                </span>
            </ng-template>
            <span class="pdf-btn" *ngIf="showCloneContractButton()">
                <por-base-button
                    *ngIf="versionToggle.isAdvanceVersion() && versionToggle.isNotQLOrConsumerQL()"
                    [theme]="'primary'"
                    [class]="'clone-button'"
                    [featureName]="'clone-contract-button'"
                    title="{{ 'RequestToBookAgainContract' | translate }}"
                    (click)="openContractCloneModal()">
                    <img class="actions-image" src="{{ uiUrl }}/assets/images/copy.svg" />
                </por-base-button>
            </span>
            <ng-container *ngIf="pdfDownloadAvailable$ | async">
                <span class="pdf-btn">
                    <por-base-button
                        (click)="downloadPdf()"
                        [loading]="(pdfDownloadUrl$ | async) === null"
                        [featureName]="'download-pdf'"
                        [title]="!(pdfDownloadAvailable$ | async | convertBoolean) ? ('Coming Soon' | translate) : ''"
                        [disabled]="(pdfDownloadAvailable$ | async | convertBoolean) === true ? false : true">
                        <img class="actions-image" [ngClass]="{ disable: !(pdfDownloadAvailable$ | async | convertBoolean) }" src="{{ uiUrl }}/assets/images/noun-pdf-file-5441350Red.svg" />
                    </por-base-button>
                </span>
            </ng-container>
        </div>
    </ng-container>
</ng-template>
<ng-template #cd_show_product_item_action_link let-text="text" let-item="item">
    <ul *ngIf="isAvoidLineItem(item); else product_item_action_link_text">
        <li>
            <a href="javascript:void(0)" (click)="loadItemActions(item)" class="btn-link" porAddFeature featureName="contract-detail-lineitem" [dynamicValue]="text">
                <span>{{ text }}</span>
            </a>
        </li>
    </ul>
    <ng-template #product_item_action_link_text>{{ text }}</ng-template>
</ng-template>

<ng-template #cd_show_product_detail_link let-text="text" let-item="item">
    <a
        href="javascript:void(0)"
        (click)="loadProductDetailModal(item?.ProductId, item?.StockId)"
        porAddFeature
        featureName="contract-detail-lineitem"
        [dynamicValue]="text"
        *ngIf="isProductDetailAvailable && isAvoidLineItem(item); else productDetailNotAvailable">
        {{ text }}
    </a>
    <ng-template #productDetailNotAvailable>
        <ng-template porFeatureAvailability [featureToken]="['canHaveSelectedItemsActions']" [fallbackTemplate]="product_detail_link_text">
            <ng-container [ngTemplateOutlet]="cd_show_product_item_action_link" [ngTemplateOutletContext]="{ text: text, item: item }"></ng-container>
        </ng-template>
    </ng-template>
    <ng-template #product_detail_link_text>
        {{ text }}
    </ng-template>
</ng-template>
<ng-template #cd_common_line_item_table>
    <ng-container *ngIf="appFacadeService.getContractDetailLineItems() | async as lineItems; else loading">
        <div *ngIf="isMobile" [ngClass]="{ 'line-items-table': true, 'quick-link-table': versionToggle.isQuickLinkVersion() }">
            <table>
                <thead>
                    <th>{{ 'Item Name' | translate }}</th>
                    <th class="text-center">{{ 'Quantity' | translate }}</th>
                    <th class="text-center">{{ 'Type' | translate }}</th>
                    <th class="text-center">{{ 'Status' | translate }}</th>
                    <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                        <!-- ADO-99020: Rate and Total are gated separately. Syrinx must show Rate but has no
                             line-level LineTotal to put in Total, so a shared gate could only ever be wrong
                             for one of the two columns. Header and body MUST split identically here and at
                             the matching cell block, or the th/td counts diverge for any org whose two
                             tokens differ - which is exactly Syrinx. -->
                        <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                            <th class="text-center">{{ 'Rate' | translate }}</th>
                        </ng-template>
                        <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                            <th class="text-center">{{ 'Total' | translate }}</th>
                        </ng-template>
                    </ng-template>
                    <th>{{ 'Item' | translate }}#</th>
                    <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                        <th class="text-center">{{ 'Documents' | translate }}</th>
                    </ng-template>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of lineItems; let i = index">
                        <tr *ngIf="i < displayedRowCount">
                            <ng-template #showLink>
                                <td class="text-left">
                                    <span *ngIf="!isNoterLineItem(item)">
                                        <ng-container
                                            [ngTemplateOutlet]="cd_show_product_detail_link"
                                            [ngTemplateOutletContext]="{ text: itemOutService.getLineItemKeyName(item), item: item }"></ng-container>
                                    </span>
                                </td>
                            </ng-template>
                            <ng-template #itemName>
                                <td [ngClass]="isNoterLineItem(item) ? 'noter-line-item' : 'text-left'">
                                    <span *ngIf="!isNoterLineItem(item); else nameText">
                                        <ng-container [ngTemplateOutlet]="cd_show_product_detail_link" [ngTemplateOutletContext]="{ text: item?.Name, item: item }"></ng-container>
                                    </span>
                                    <ng-template #nameText>
                                        <span>{{ item?.Name }}</span>
                                    </ng-template>
                                </td>
                            </ng-template>
                            <ng-template porFeatureAvailability [featureToken]="['canHaveSelectedItemsActions']" [fallbackTemplate]="itemName">
                                <td [ngClass]="isNoterLineItem(item) ? 'noter-line-item' : 'text-left'">
                                    <ng-container [ngTemplateOutlet]="cd_show_product_item_action_link" [ngTemplateOutletContext]="{ text: item?.Name, item: item }"></ng-container>
                                </td>
                            </ng-template>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ item?.Quantity }}</span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ isSaleorRentalorNull(item.Classification) ? (item?.Classification ?? '' | translate) : '' }}</span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ item?.Status }}</span>
                            </td>
                            <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                                <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                                    <td class="text-center">
                                        <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ isRental(item.Classification) ? (item?.SingleRate | formatCurrency) : '' }}</span>
                                    </td>
                                </ng-template>
                                <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                                    <td class="text-center">
                                        <span *ngIf="!isNoterLineItem(item)">{{ item?.LineTotal !== null ? (item?.LineTotal | formatCurrency) : (0 | formatCurrency) }}</span>
                                    </td>
                                </ng-template>
                            </ng-template>
                            <td *ngIf="!(item?.ProductId ?? item?.StockId); else showLink">
                                <span *ngIf="!isNoterLineItem(item)">{{ itemOutService.getLineItemKeyName(item) }}</span>
                            </td>
                            <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                                <td *ngIf="isRental(item.Classification)" class="document-data">
                                    <div class="doc-btn" *ngIf="!isNoterLineItem(item)">
                                        <por-base-button (click)="loadDocuments(item)">
                                            <img class="actions-image" src="{{ uiUrl }}/assets/images/document-icon.svg" />
                                        </por-base-button>
                                    </div>
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                    <tr *ngIf="getDamageWaiver() > 0">
                        <td class="text-left">{{ 'damageWaiver' | translate }}</td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                            <!-- ADO-99020: Rate and Total are gated separately in the header and item rows, so this row
                                 must place its empty Rate cell behind canSeeRates and its Total cell behind canSeeAmounts.
                                 Gating both on canSeeAmounts shifts every later column for Syrinx (Rate on, Total off). -->
                            <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                                <td class="text-center"></td>
                            </ng-template>
                            <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                                <td class="text-center">{{ getDamageWaiver() | formatCurrency }}</td>
                            </ng-template>
                        </ng-template>
                        <td class="text-center"></td>
                        <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                            <td class="text-center"></td>
                        </ng-template>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="line-items-table" *ngIf="!isMobile">
            <table>
                <thead>
                    <th class="text-left">{{ 'Item' | translate }}#</th>
                    <th class="text-left">{{ 'Item Name' | translate }}</th>
                    <th class="text-center">{{ 'Quantity' | translate }}</th>
                    <th class="text-center">{{ 'Type' | translate }}</th>
                    <th class="text-center">{{ 'Status' | translate }}</th>
                    <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                        <!-- ADO-99020: Rate and Total are gated separately. Syrinx must show Rate but has no
                             line-level LineTotal to put in Total, so a shared gate could only ever be wrong
                             for one of the two columns. Header and body MUST split identically here and at
                             the matching cell block, or the th/td counts diverge for any org whose two
                             tokens differ - which is exactly Syrinx. -->
                        <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                            <th class="text-center">{{ 'Rate' | translate }}</th>
                        </ng-template>
                        <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                            <th class="text-center">{{ 'Total' | translate }}</th>
                        </ng-template>
                    </ng-template>
                    <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                        <th class="text-center">{{ 'Documents' | translate }}</th>
                    </ng-template>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of lineItems; let i = index">
                        <tr *ngIf="i < displayedRowCount">
                            <td *ngIf="!(item?.ProductId ?? item?.StockId); else showLink" class="text-left">
                                <span *ngIf="!isNoterLineItem(item)">{{ itemOutService.getLineItemKeyName(item) }}</span>
                            </td>
                            <ng-template #showLink>
                                <td class="text-left">
                                    <span *ngIf="!isNoterLineItem(item)">
                                        <ng-container
                                            [ngTemplateOutlet]="cd_show_product_detail_link"
                                            [ngTemplateOutletContext]="{ text: itemOutService.getLineItemKeyName(item), item: item }"></ng-container>
                                    </span>
                                </td>
                            </ng-template>
                            <ng-template #itemName>
                                <td [ngClass]="isNoterLineItem(item) ? 'noter-line-item' : 'text-left'">
                                    <span *ngIf="!isNoterLineItem(item); else nameText">
                                        <ng-container [ngTemplateOutlet]="cd_show_product_detail_link" [ngTemplateOutletContext]="{ text: item?.Name, item: item }"></ng-container>
                                    </span>
                                    <ng-template #nameText>
                                        <span>{{ item?.Name }}</span>
                                    </ng-template>
                                </td>
                            </ng-template>
                            <ng-template porFeatureAvailability [featureToken]="['canHaveSelectedItemsActions']" [fallbackTemplate]="itemName">
                                <td [ngClass]="isNoterLineItem(item) ? 'noter-line-item' : 'text-left'">
                                    <ng-container [ngTemplateOutlet]="cd_show_product_item_action_link" [ngTemplateOutletContext]="{ text: item?.Name, item: item }"></ng-container>
                                </td>
                            </ng-template>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item)">{{ item?.Quantity }}</span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ isSaleorRentalorNull(item.Classification) ? (item?.Classification ?? '' | translate) : '' }}</span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ item?.Status }}</span>
                            </td>
                            <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                                <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                                    <td class="text-center">
                                        <span *ngIf="!isNoterLineItem(item) && isAvoidLineItem(item)">{{ isRental(item.Classification) ? (item?.SingleRate | formatCurrency) : '' }}</span>
                                    </td>
                                </ng-template>
                                <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                                    <td class="text-center">
                                        <span *ngIf="!isNoterLineItem(item)">{{ item?.LineTotal !== null ? (item?.LineTotal | formatCurrency) : (0 | formatCurrency) }}</span>
                                    </td>
                                </ng-template>
                            </ng-template>
                            <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                                <td *ngIf="isRental(item.Classification)" class="document-data">
                                    <div class="doc-btn" *ngIf="!isNoterLineItem(item)">
                                        <por-base-button (click)="loadDocuments(item)">
                                            <img class="actions-image" src="{{ uiUrl }}/assets/images/document-icon.svg" />
                                        </por-base-button>
                                    </div>
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                    <tr *ngIf="getDamageWaiver() > 0">
                        <td class="text-left"></td>
                        <td class="text-left">{{ 'damageWaiver' | translate }}</td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                            <!-- ADO-99020: Rate and Total are gated separately in the header and item rows, so this row
                                 must place its empty Rate cell behind canSeeRates and its Total cell behind canSeeAmounts.
                                 Gating both on canSeeAmounts shifts every later column for Syrinx (Rate on, Total off). -->
                            <ng-template porFeatureAvailability [featureToken]="['canSeeRates']">
                                <td class="text-center"></td>
                            </ng-template>
                            <ng-template porFeatureAvailability [featureToken]="['canSeeAmounts']">
                                <td class="text-center">{{ getDamageWaiver() | formatCurrency }}</td>
                            </ng-template>
                        </ng-template>
                        <ng-template porFeatureAvailability [featureToken]="['showDetailDocuments']">
                            <td class="text-center"></td>
                        </ng-template>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="lineItems.length > displayedRowCount" class="middle">
            <por-load-more [featureName]="'contract-detail-load-more'" [displayedRowCount]="displayedRowCount" [totalRowCount]="lineItems.length" (loadMore)="handleLoadMore($event)"></por-load-more>
        </div>
    </ng-container>
    <ng-template #loading>
        <por-busy-indicator [message]="'Loading' | translate" />
    </ng-template>
</ng-template>

<ng-template #cd_common_selected_item_documents>
    <!-- ADO-120176: cues the customer that at least one step below still needs action (see
         showIncompleteStepsBanner(): QuickLink Quote, eSign outstanding OR required payment incomplete). -->
    <div class="incomplete-steps-banner" *ngIf="showIncompleteStepsBanner()">
        <p class="incomplete-steps-banner-text">{{ 'IncompleteStepsBannerMessage' | translate }}</p>
    </div>
    <ng-container *ngIf="isPaymentProcessorAvailable$ | async">
        <por-base-button [theme]="'primary'" [featureName]="'payment-button'" class="split-button" (click)="enablePaymentPage(true)" *ngIf="isPaymentEnabled && !isPaymentAccordionVisible">
            <span class="actions-image">
                <svg
                    class="fill-current"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 100 100"
                    style="enable-background: new 0 0 100 100"
                    xml:space="preserve">
                    <g id="credit-card-payment" transform="translate(3 2)">
                        <g transform="matrix(1, 0, 0, 1, -3, -2)">
                            <path id="Path_11200-2" d="M77.1,36.8c1.2,0,2.3,0.2,3.4,0.5l9.8-9.8l-4.6-4.6L71.9,36.8H77.1z" />
                        </g>
                        <g transform="matrix(1, 0, 0, 1, -3, -2)">
                            <path
                                id="Path_11201-2"
                                d="M96.9,34.1l-2.5-2.5l-8.9,8.9c2,2.1,3.1,4.9,3.1,7.8v2.3l8.3-8.3C99.1,40,99.1,36.3,96.9,34.1
                            C96.9,34.1,96.9,34.1,96.9,34.1z" />
                        </g>
                        <g transform="matrix(1, 0, 0, 1, -3, -2)">
                            <path id="Path_11202-2" d="M81.7,18.8L65.2,2.4c-2.2-2.2-5.9-2.2-8.1,0c0,0,0,0,0,0L22.7,36.8h41L81.7,18.8z" />
                        </g>
                        <path id="Path_11203" d="M12.6,58.7h8.8v6.5h-8.8V58.7z" />
                        <g transform="matrix(1, 0, 0, 1, -3, -2)">
                            <path
                                id="Path_11204-2"
                                d="M77.1,42.5H6.2c-3.2,0-5.7,2.6-5.7,5.7V93c0,3.2,2.6,5.7,5.7,5.7c0,0,0,0,0,0h70.8
                            c3.2,0,5.7-2.6,5.7-5.7l0,0V48.2C82.8,45.1,80.2,42.5,77.1,42.5z M9.8,55h20.2v18H9.8V55z M21,86.3H9.7v-5.7H21V86.3z M38.6,86.3
                            H27.2v-5.7h11.4V86.3z M56.1,86.3H44.8v-5.7h11.3V86.3z M73.6,86.3H62.3v-5.7h11.4L73.6,86.3z" />
                        </g>
                    </g>
                </svg>
            </span>
            <span class="line-splitter">{{ 'Make a payment' | translate }}</span>
        </por-base-button>
    </ng-container>
</ng-template>

<ng-container *ngFor="let detail of contractDetail">
    <por-app-confirm-dialog [dialogType]="dialogType" (confirmed)="cancelContract($event, detail.Id)" *ngIf="isDialogEnabled"></por-app-confirm-dialog>
</ng-container>

<por-base-modal [id]="'clone-contract-request-modal'" [modalWidth]="'modal-lg'" (onclose)="onCloseContractCloneModal()">
    <ng-container *ngIf="appFacadeService.getContractDetail() | async as data">
        <por-book-again-contract-modal [customerId]="customerId" [contractDetail]="[data]" [uiUrl]="uiUrl" (isContractFormSubmittedSuccess)="closeContractCloneModal()"></por-book-again-contract-modal>
    </ng-container>
</por-base-modal>

<por-base-modal [id]="'contract-payment-history-modal'" [modalWidth]="'modal-lg'" (onclose)="onClosePaymentHistoryModal()">
    <ng-container *ngIf="appFacadeService.getContractDetail() | async as data">
        <por-contract-payment-history-modal [contractDetail]="[data]"></por-contract-payment-history-modal>
    </ng-container>
</por-base-modal>

<por-payment-success-dialog *ngIf="versionToggle.isQuickLinkVersion()"></por-payment-success-dialog>
